import { CommonService, PartRequestService, PartAvailabilitySubmitModel, StockPart } from 'api-new/generated';
import { QueryError, formatErrorMessage } from 'features/shared/model';
import { UseMutationOptions, useMutation } from 'react-query';
import { toast } from 'react-toastify';

type PartsBranchAvailabilityInput = {
  id: number;
  requestBody?: Array<StockPart>;
};

export const usePartsBranchAvailabilityMutation = (
  options?: Omit<
    UseMutationOptions<
      Awaited<ReturnType<typeof PartRequestService.postPartsBranchAvailability>>,
      QueryError,
      PartsBranchAvailabilityInput,
      unknown
    >,
    'mutationFn'
  >
) =>
  useMutation(
    ({ id, requestBody }: PartsBranchAvailabilityInput) => {
      return PartRequestService.postPartsBranchAvailability(id, requestBody);
    },
    {
      ...options,
      onSuccess: () => {
        toast.success('Successfully updated!');
      },
      onError: (error: QueryError) => {
        const message = formatErrorMessage(error);
        toast.error(message);
        console.error(message);
      }
    }
  );
